import { SearchResultInfo } from '@smart-tv/typings/search';

import { kmm } from './kmm';
import { mapSearchResult } from './search-helpers';

export async function search(query: string): Promise<SearchResultInfo> {
  const result = await kmm((repo) => repo.search(query));

  return mapSearchResult(result);
}

export default search;
